import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardBody, Button, Row, } from 'reactstrap';

import { Separator, Colxx } from '../../../../../../components/common/CustomBootstrap';
import UrlNudgesForm from './UrlNudgesForm';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { gAPI_NudgesButtonList, putAPI_Update_Response, putAPI_Update_UrlNudgeButton } from '../../../../../../constants/APIs';

export default function UrlNudgesSetting({
    integration,
    nudges,
    locale,
    integrationId
}) {

    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [nudgeData, setNudge] = useState({});
    const [nudgeId, setNudgeId] = useState('');
    const [urlBasedNudges, setUrlBasedNudges] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {

        setUrlBasedNudges(nudges);
    }, [nudges]);


    const edit = (data) => {
        setNudge(data);
        setNudgeId(data.id);
        setIsEditing(true);
        setIsUpdating(true);
    };


    const handleAddUrlNudge = () => {
        setNudge({});
        setIsEditing(false);
        setIsUpdating(true);
    };


    const handleSubmit = (eyeCatcherData, data) => {
        setIsLoading(true);
        console.log('Submitting update for:', eyeCatcherData, data);
        try {

            AxiosAPI({
                method: 'put',
                url: putAPI_Update_Response,
                data: eyeCatcherData,
            })
                .then((response) => {

                    if (response.data.HttpStatusCode !== undefined && response.data.HttpStatusCode === 400 && response.data.Messages !== undefined
                        && response.data.Messages !== null && response.data.Messages.length > 0) {
                        setMsg(response.data.Messages);

                        setOpen(true);
                    }
                    else {
                        AxiosAPI({
                            method: 'put',
                            url: `${putAPI_Update_UrlNudgeButton}/${integration.id}?group_id=${getGroupID()}`,
                            data: data,
                        })
                            .then((res) => {

                                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                                    setMsg(res.data.Messages);

                                    setOpen(true);
                                }
                                else {

                                    setUrlBasedNudges(prevNudges =>
                                        prevNudges.map(nudge =>
                                            (nudge.id === data.id && nudge.eyeCatcher !== undefined && nudge.eyeCatcher?.query.code === eyeCatcherData.Code)
                                                ? {
                                                    ...nudge,
                                                    eyeCatcher: {
                                                        ...nudge.eyeCatcher,
                                                        response: {
                                                            ...nudge.eyeCatcher?.response,
                                                            messages: eyeCatcherData.Default,
                                                        },

                                                    },
                                                    delayInMilliseconds: data.delayInMilliseconds,
                                                    delayInMillisecondsInMobile: data.delayInMillisecondsInMobile,
                                                    disabledInDesktop: data.disabledInDesktop,
                                                    disabledInMobile: data.disabledInMobile,
                                                    buttons: data.buttons,
                                                    otherLanguages: data.otherLanguages,
                                                    pageURL: data.pageURL,
                                                    displayOrder: data.displayOrder,

                                                }
                                                : nudge
                                        )
                                    );


                                    // setTimeout(function () {
                                    //     window.location.reload();
                                    // }, 1000);
                                    setIsUpdating(false);
                                    setIsLoading(false);
                                }


                            });
                    }

                });
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <Card className="mb-4">
            <CardBody>
                <h6 className="text-center">URL Based Nudges</h6>
                <div className='text-center'>
                    <Button
                        onClick={handleAddUrlNudge}
                        color="primary"
                        size="lg"
                        style={{ margin: '6px' }}
                    >
                        + URL based Nudges
                    </Button>
                </div>
                {isLoading ? <div className="loading" /> :
                    <div className="equal-height-container mb-5 row">
                        {urlBasedNudges && urlBasedNudges.map((nudge, index) => (
                            <div key={index} className="col-item mb-4 col-md-12 col-lg-6">
                                <div className="card">
                                    <div className="pt-5 pb-5 d-flex flex-lg-column flex-md-row flex-sm-row flex-column card-body">
                                        <div className="price-top-part">
                                            <h5 className="mb-0 font-weight-semibold color-theme-1 mb-1">Eye Catcher</h5>
                                            <p className="mb-2">
                                                {nudge.eyeCatcher && nudge.eyeCatcher.response && nudge.eyeCatcher.response.messages
                                                    ? nudge.eyeCatcher.response.messages[0]
                                                    : null}
                                            </p>
                                        </div>
                                        <div className="price-top-part">
                                            <h5 className="text-center mb-2"><strong>Url</strong></h5>
                                            <p className="mb-2">{nudge.pageURL}</p>
                                        </div>
                                        <div className="price-top-part">
                                            <b>Display Order</b>
                                            <p className="mb-2">{nudge.displayOrder}</p>
                                        </div>
                                        <Separator className="mb-3" />

                                        <div className="pl-3 pr-3 pb-0 d-flex price-feature-list flex-column flex-grow-1">
                                            <p className="text-center mb-2"><strong>Desktop</strong></p>
                                            <Separator className="mb-3" />
                                            <Row>
                                                <Colxx sm={12} className="mb-2">
                                                    <Card className="text-center">
                                                        <div style={{ padding: "10px", marginTop: "0px" }}>
                                                            <b>Delay in Seconds</b><br />
                                                            <p className="mb-2">{nudge.delayInMilliseconds / 1000 || 0}</p>
                                                            <b>Enabled</b><br />
                                                            <p>{!nudge.disabledInDesktop ? "Yes" : "No"}</p>
                                                        </div>
                                                    </Card>
                                                </Colxx>
                                            </Row>
                                            <p className="text-center mb-2"><strong>Mobile</strong></p>
                                            <Separator className="mb-3" />
                                            <Row>
                                                <Colxx sm={12} className="mb-2">
                                                    <Card className="text-center">
                                                        <div style={{ padding: "10px", marginTop: "0px" }}>
                                                            <b>Delay in Seconds</b><br />
                                                            <p className="mb-2">{nudge.delayInMillisecondsInMobile / 1000 || 0}</p>
                                                            <b>Enabled</b><br />
                                                            <p>{!nudge.disabledInMobile ? "Yes" : "No"}</p>
                                                        </div>
                                                    </Card>
                                                </Colxx>
                                            </Row>

                                            {nudge.buttons && nudge.buttons.length > 0 && (
                                                <Fragment>
                                                    <p className="text-center mb-2"><strong>Buttons</strong></p>
                                                    <Separator className="mb-2" />
                                                    <Row>
                                                        <Colxx sm={12} className="mb-2">
                                                            <Card>
                                                                <div className='p-1 mt-1 text-center'>
                                                                    {nudge.buttons.map((item, i) =>
                                                                        <span key={i} className="mb-1 mr-1 badge badge-outline-primary badge-pill">{item.text}</span>
                                                                    )}
                                                                </div>
                                                            </Card>
                                                        </Colxx>
                                                    </Row>
                                                </Fragment>
                                            )}
                                            <Button
                                                size="xs"
                                                color="success"
                                                outline
                                                style={{ marginTop: '5px' }}
                                                onClick={() => { edit(nudge) }}
                                            >
                                                Edit
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                }
            </CardBody>

            {isUpdating && (
                <UrlNudgesForm
                    integration={integration}
                    formLabel={isEditing ? "Update Nudges" : "Add URL Based Nudge"}
                    visible={isUpdating}
                    toggle={() => setIsUpdating(!isUpdating)}
                    isEditing={isEditing}
                    submit={handleSubmit}
                    urlBasedNudges={urlBasedNudges}
                    setUrlBasedNudges={setUrlBasedNudges}
                    nudgeId={isEditing ? nudgeId : {}}
                    integrationLanguages={integration.botSettings.languages}
                    locale={locale}
                />
            )}
        </Card>
    );
}
